import { gql } from '@apollo/client';
import { Box, Center } from '@chakra-ui/react';
import { PropsWithChildren } from 'react';
import { CellProps } from 'react-table';
import { ConfigurationStatusBox } from '~components/configurations/ConfigurationStatus';
import { ConfigurationStatus } from '~graphql/__generated__/types';
import { ConfigurationTable_ConfigurationFragment } from '../__generated__/ConfigurationsTable.graphql';

export function StatusCell({
  value,
}: PropsWithChildren<CellProps<ConfigurationTable_ConfigurationFragment, ConfigurationStatus>>) {
  return (
    <Box overflow="hidden" textOverflow="ellipsis" whiteSpace="nowrap">
      <Center>
        <ConfigurationStatusBox state={value} />
      </Center>
    </Box>
  );
}

StatusCell.graphql = {
  fragments: {
    StatusCell_powerSchedule: gql`
      fragment StatusCell_configuration on ConfigurationModel {
        id
        state
      }
    `,
  },
};
